import React from "react";
import { motion } from "framer-motion";
type PolaroidProps = {
  src: string;
  label: string;
  rotate?: number;
  className?: string;
  delay?: number;
};
export function Polaroid({
  src,
  label,
  rotate = 0,
  className = "",
  delay = 0
}: PolaroidProps) {
  return <motion.figure className={`bg-white p-2 pb-1 shadow-[0_20px_40px_-15px_rgba(59,34,25,0.45)] ${className}`} style={{
    rotate
  }} initial={{
    opacity: 0,
    scale: 0.96
  }} animate={{
    opacity: 1,
    scale: 1,
    y: [0, -10, 0]
  }} transition={{
    opacity: {
      duration: 0.3,
      delay
    },
    scale: {
      duration: 0.3,
      delay
    },
    y: {
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut",
      delay
    }
  }} data-id="element-604" data-mp="19h51fi5hiqal">
      <img src={src} alt={label} className="aspect-square w-full object-cover" data-id="element-605" data-mp="vmkqlobkd944" />
      <figcaption className="py-1 text-center font-script text-xl text-cocoa" data-id="element-606" data-mp="hnuuaawkjdgt">{label}</figcaption>
    </motion.figure>;
}